module.exports = __webpack_public_path__ + "static/media/1_en.ef8d2703.png";